export class QueryParamRequest {
  key: string;
  value: string;
}
export class AccessedPageLogRequest {
  page: string;
  queryParams: Array<QueryParamRequest>;
}
